import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utils/cn';

type Props = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
  as?: 'section' | 'article' | 'div';
};

/** Surface card for board sections and plan panels. */
export function SectionCard({ children, className, as: Tag = 'section', ...rest }: Props) {
  return (
    <Tag
      className={cn(
        'rounded-[20px] border border-[var(--border)] bg-[var(--card)] p-4 shadow-[var(--shadow-card)] md:p-6',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
